// @module SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems
define("SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems.View", [
  "suitedb_sdbservicehardwareitems_sdbservicehardwareitems.tpl",
  "SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems.Model",
  "Backbone",
  "SuiteDB.SDBServiceHardwareItems.Image.View",
], function (
  suitedb_sdbservicehardwareitems_sdbservicehardwareitems_tpl,
  SDBServiceHardwareItemsModel,
  Backbone,
  ImageView
) {
  "use strict";

  return Backbone.View.extend({
    template: suitedb_sdbservicehardwareitems_sdbservicehardwareitems_tpl,

    initialize: function initialize(options) {
      //attributes
      this.options = options;
      this.model = SDBServiceHardwareItemsModel.getInstance();
      this.suggestions = [];
      this.model.cartView = this;

      this.getSelection = function (e) {
        var serviceCheck = $(e.target)
          .parents(".suggested-item__module")[0]
          .querySelector('input[type="checkbox"]');
        if (!serviceCheck) return;
        var serviceId = serviceCheck.getAttribute("data-value");
        if (!serviceId) return;

        var itemId;
        if ($(e.target).parents(".grouped").length) {
          var itemElements = $(e.target)
            .parents(".suggested-item")[0]
            .querySelectorAll(".item-name-display");
          if (!itemElements.length) return;
          itemId = _.map(
            itemElements,
            function (value) {
              return Number(value.getAttribute("data-value"));
            },
            {}
          );
        } else {
          var itemElement = $(e.target)
            .parents(".suggested-item")[0]
            .querySelector(".item-name-display");
          if (!itemElement) return;
          itemId = Number(itemElement.getAttribute("data-value"));
        }
        if (!itemId) return;

        var input = $(e.target)
          .parents(".suggested-item__module")[0]
          .querySelector('input[type="number"]');
        if (!input) return;
        var quantity = Number(input.value);
        if (!quantity || quantity < 1) return;

        var isHardware = false;
        if ($(e.target).parents(".hardware-container").length)
          isHardware = true;

        return {
          item: itemId,
          id: serviceId,
          quantity: quantity,
          isHardware: isHardware,
        };
      };
      this.render = _.wrap(this.render, function (fn) {
        fn.apply(this, _.toArray(arguments).slice(1));
        setTimeout(function () {
          //disable button until at least one suggestion is selected
          var addSuggestionsButton = document.querySelector(
            ".add-recommendations-to-cart"
          );
          if (addSuggestionsButton) addSuggestionsButton.disabled = true;
        }, 0);
      });
    },

    events: {
      "click .service-quantity-button": "changeQuantity",
      "change .quantity-input": "changeQuantity",
      "click .checkbox-service-selection": "selectService",
      "click .add-recommendations-to-cart": "addSuggestions",
      'click [data-action="showImageModal"]': "showImageModal",
    },

    bindings: {},

    childViews: {},
    addSuggestions: function changeQuantity(e) {
      this.model.updateCart();
    },
    selectService: function selectService(e) {
      var selection = this.getSelection(e);
      if (!selection) {
        e.preventDefault();
        return;
      }

      //disable button if no suggestions selected
      var checkedServices = $(e.target)
        .parents(".suggested-item-list")[0]
        .querySelectorAll(".checkbox-service-selection:checked");
      var addSuggestionsButton = document.querySelector(
        ".add-recommendations-to-cart"
      );
      if (addSuggestionsButton && checkedServices.length)
        addSuggestionsButton.disabled = false;
      else addSuggestionsButton.disabled = true;

      if (!e.target.checked) {
        this.model.removeSelection(selection);
        return;
      }
      this.model.addSelection(selection);
    },
    changeQuantity: function changeQuantity(e) {
      var input = $(e.target)
        .parents(".suggested-item__module")[0]
        .querySelector('input[type="number"]');
      if (!input) return;
      var numberValue = Number(input.value);
      if (isNaN(numberValue)) return;
      if (e.target.innerHTML == "+") numberValue++;
      else if (e.target.innerHTML == "-") numberValue--;

      if (numberValue < 1) numberValue = 1;
      input.value = numberValue;

      var selection = this.getSelection(e);
      if (!selection) return;

      var selectedIndex = _.findIndex(
        this.model.selectedServices,
        function (value) {
          return value.id == selection.id;
        }
      );
      if (selectedIndex == -1 && !selection.isHardware) return;

      selection.quantity = Number(input.value);
      this.model.addSelection(selection);
    },
    showImageModal: function showImageModal(e) {
      var layout = this.options.container.getComponent("Layout");
      var modalView = new ImageView({
        container: this.container,
        image: e.target.src,
        pageHeader: e.target.alt,
      });
      layout.showContent(modalView, { showInModal: true });
    },

    getContext: function getContext() {
      var contextSelf = this;
      var suggestions = _.map(contextSelf.model.suggestions, _.clone);
      var result = [];
      //group all items with the same value for grouping
      var byDiameter = _.groupBy(suggestions, function (s) {
        if (!s.item.groupValue) return -1;
        else return s.item.groupValue;
      });
      //leave the suggestions without a value for grouping as they are
      if (byDiameter[-1]) {
        _.each(byDiameter[-1], function (s) {
          s.item = [s.item];
          result.push(s);
        });
        delete byDiameter[-1];
      }

      _.each(byDiameter, function (group) {
        //dont group items that are not tires or wheels
        var groupCopy = _.map(group, _.clone);
        _.each(groupCopy, function (s) {
          var itemClass = s.item.class.toLowerCase();
          if (
            itemClass.indexOf("tires") != 0 &&
            itemClass.indexOf("wheels") != 0
          ) {
            s.item = [s.item];
            result.push(s);
            var indexToRemove = _.findIndex(group, function (groupEntry) {
              return (groupEntry.item.id = s.item.id);
            });
            if (indexToRemove != -1) group.splice(indexToRemove, 1);
          }
        });

        //only proceed with the grouping if there is at least one tire and one wheel
        var wheelQuantity = 0;
        var tireQuantity = 0;
        var itemTypesInGroup = _.chain(group)
          .map(function (value) {
            var itemClass = value.item.class.toLowerCase();
            var quantityForItem = 0;
            if (value.services[0]) quantityForItem = value.services[0].quantity;
            if (itemClass.indexOf("tires") == 0) {
              tireQuantity += quantityForItem;
              return "tires";
            } else if (itemClass.indexOf("wheels") == 0) {
              wheelQuantity += quantityForItem;
              return "wheels";
            }
          }, {})
          .uniq()
          .value();
        if (itemTypesInGroup.length != 2) {
          _.each(group, function (s) {
            s.item = [s.item];
            result.push(s);
          });
          return;
        }

        //extract the ids of services that are suggested for more than one item
        var allServiceObjects = _.flatten(_.pluck(group, "services"), true);
        var allServiceIDs = _.pluck(allServiceObjects, "id");
        var counts = _.countBy(allServiceIDs, function (id) {
          return id;
        });
        var sharedIDs = [];
        _.each(counts, function (cnt, id) {
          if (cnt > 1) sharedIDs.push(parseInt(id, 10));
        });

        //add individual suggestions to the final result without the shared services
        groupCopy = _.map(group, _.clone);
        _.each(groupCopy, function (s) {
          s.services = _.reject(s.services, function (service) {
            return _.contains(sharedIDs, Number(service.id));
          });
          s.item = [s.item];
          result.push(s);
        });

        //add the grouped suggestions to the final result
        _.each(sharedIDs, function (id) {
          var itemsWith = _.pluck(
            _.filter(group, function (s) {
              return _.some(_.pluck(s.services, "id"), function (sid) {
                return Number(sid) === id;
              });
            }),
            "item"
          );
          var serviceObject = _.findWhere(allServiceObjects, {
            id: String(id),
          });
          serviceObject.quantity = _.min([wheelQuantity, tireQuantity]);
          serviceObject.quantity =
            (serviceObject.class &&
              /\b(ALIGNMENTS?)\b/i.test(serviceObject.class.toUpperCase())) ||
            /\b(ALIGNMENT?)\b/i.test(serviceObject.display.toUpperCase())
              ? Math.ceil(serviceObject.quantity / 4)
              : serviceObject.quantity;

          //remove items from group if the service is already selected for that item
          _.each(
            contextSelf.model.selectedServices,
            function (selectedService) {
              if (!(selectedService.id == serviceObject.id)) return;

              itemsWith = _.reject(itemsWith, function (item) {
                return _.contains(selectedService.item, item.id);
              });
            }
          );
          if (!itemsWith.length) return;

          var groupedSuggestion = {
            item: itemsWith,
            services: [serviceObject],
            hardware: [],
          };
          if (itemsWith.length >= 1) groupedSuggestion.groupedSuggestion = true;

          result.push(groupedSuggestion);
        });
      });
      this.suggestions = result || [];

      //group all suggestions that apply to the same item set
      this.suggestions = _.chain(this.suggestions)
        .groupBy(function (suggestion) {
          var ids = _.pluck(suggestion.item, "id").sort();
          return ids.join("-");
        })
        .map(function (group) {
          var groupCopy = _.clone(group[0]);
          groupCopy.services = _.flatten(_.pluck(group, "services"), true);
          groupCopy.hardware = _.flatten(_.pluck(group, "hardware"), true);
          return groupCopy;
        })
        .value();

      var applicable = !!(this.suggestions.length > 0);
      return {
        applicable: applicable,
        suggestions: this.suggestions,
      };
    },
  });
});
